import enUS from './en-US'
import enGB from './en-GB'

export default {
  'en-US': enUS,
  'en-GB': enGB,
}
